import { AxiosService } from 'src/services/AxiosService';
import {GrouperServiceConverter} from 'src/services/converters/GrouperServiceConverter';
import {AnalyseCode, DrgAnalyseResponseDto} from 'src/contracts/drgAnalyseResponseDto';
import {DrgAnalysis, DrgAnalysisCode} from 'src/contracts/drgAnalysis';
import {AnalyzeDrgRequestDto} from 'src/contracts/analyzeDrgRequestDto';
import {CodeType} from "src/contracts/codeType";

/**
 * Service for interacting with the backend User service.
 */
export class UserSettingsService extends AxiosService {
  async getUserPreference(preference: string, defaultValue: string): Promise<string | undefined> {
    const result =  await this.axiosCall<string>({
      method: 'get',
      url: `/profile-settings/preferences/${preference}/default/${defaultValue}`,
    });

    if (result.err) {
      console.log(`[ResourceService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }

    return result.data;
  }

  async setUserPreference(preference: string, value: string): Promise<void> {
    const result =  await this.axiosCall<string>({
      method: 'put',
      url: `/profile-settings/preferences/${preference}/value/${value}`,
    });

    if (result.err) {
      console.log(`[ResourceService] Error: ${(<Error>result.err).message}`);
      throw new Error((<Error>result.err).message);
    }
  }
}